// extracted by mini-css-extract-plugin
module.exports = {"fact":"Facts_fact__2hrgk","amount":"Facts_amount__yBFV1","text":"Facts_text__EbICO"};